import React, { ComponentType, Fragment, forwardRef } from 'react'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { Experiments, ExperimentsSymbol } from '@wix/thunderbolt-symbols'
import { ServicesManagerProvider } from '@wix/services-manager-react'
import type { ServicesManager } from '@wix/services-manager/types'

export const ServicesManagerProviderWrapper = withDependencies([ExperimentsSymbol], (experiments: Experiments) => {
	return {
		wrapComponent: (Component: ComponentType<any>, compType: string) => {
			const Wrapper = forwardRef<any, any>((props, ref) => {
				const isServicesInfraEnabled = !!experiments['specs.thunderbolt.servicesInfra']
				const pageCompTypes = new Set(['PageMountUnmount', 'MasterPage'])

				if (isServicesInfraEnabled && pageCompTypes.has(compType)) {
					const { compProps, ...restProps } = props
					const { servicesManager, ...restCompProps } = compProps || {}
					const ServiceWrapper = (servicesManager ? ServicesManagerProvider : Fragment) as ComponentType<{
						servicesManager?: ServicesManager
						children?: React.ReactNode
					}>

					const serviceWrapperProps = servicesManager ? { servicesManager } : {}

					return (
						<ServiceWrapper {...serviceWrapperProps}>
							<Component {...restProps} compProps={restCompProps} ref={ref} />
						</ServiceWrapper>
					)
				}

				return <Component {...props} ref={ref} />
			})
			return Wrapper
		},
	}
})
